<template>
  <div class="page h-100">
    <div class="container pt-82">
      <div class="font-40 color-ff font-yahei text-center mb-4">看案例</div>
      <div class=" font-yahei font-16 color-ca text-center mb-90">我们只做有温度的设计</div>
      <div class="menu flex">
        <div class="flex-1 flex-column justify-center">
          <div class="flex align-start">
            <img src="/images/xuanxiang-fengge.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">风格</div>
            <div class="line"></div>
            <div class="flex flex-wrap w-0 flex-1">
              <button class="menu-item font-12" :class="styleIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'styleIndex')">不限</button>
              <button class="menu-item font-12" :class="styleIndex === index ? 'active' : ''" v-for="(item, index) in styleList" :key="index" @click="chooseMenu(index, 'styleIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-fangxing.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">房型</div>
            <div class="line"></div>
            <div class="flex flex-wrap w-0 flex-1">
              <button class="menu-item font-12" :class="layoutIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'layoutIndex')">不限</button>
              <button class="menu-item font-12" :class="layoutIndex === index ? 'active' : ''" v-for="(item, index) in layoutList" :key="index" @click="chooseMenu(index, 'layoutIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-gengduo.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">面积</div>
            <div class="line"></div>
            <div class="flex flex-wrap w-0 flex-1">
              <button class="menu-item font-12" :class="areaIndex ===  -1 ? 'active' : ''" @click="chooseMenu( -1, 'areaIndex')">不限</button>
              <button class="menu-item font-12" :class="areaIndex === index ? 'active' : ''" v-for="(item, index) in areaList" :key="index" @click="chooseMenu(index, 'areaIndex')">{{item.minArea}}{{item.maxArea ? -item.maxArea+'㎡' : '㎡以上'}} </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>看案例</el-breadcrumb-item>
          <el-breadcrumb-item>共{{total}}个案例</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="hr mb-10"></div>
      <div class="flex align-center sort mb-30">
        <button class="font-12 cursor" :class="isSales === '' && isPrice === '' ? 'color-c19357' : 'color-94'" @click="onSort('')">综合排序</button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isSales !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isSales')">
          销量
          <img :src="isSales === 1  ? '/images/paixu-jiangxu.png' : isSales === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isPrice !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isPrice')">
          价格
          <img :src="isPrice === 1  ? '/images/paixu-jiangxu.png' : isPrice === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
      </div>
      <div class="flex flex-wrap mb-40">
        <div v-for="(item, index) in caseList" :key="index" class="case-item" :class="index%2 === 0 ? '' : 'ml-20'" @click="toDetail(item.id)">
          <div class="pic mb-28" v-if="item.casePicList && item.casePicList.length>0">
            <el-image :src="Utils.IMG_PREV + item.casePicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
          </div>
          <div class="mask flex align-center justify-center">
            <div class="btn-40 border-ff radius-round font-16 font-yahei w-124">案例详情</div>
          </div>
          <div class="flex align-center">
            <div class="flex-1">
              <div class="font-30 color-292a2e font-yahei mb-14">{{item.name}}</div>
              <div class="flex align-center">
                <div>
                  <div class="color-94 font-12 mb-4">设计风格</div>
                  <div class="color-292a2e font-16 font-yahei">{{item.style}}</div>
                </div>
                <div class="line"></div>
                <div>
                  <div class="color-94 font-12 mb-4">房屋户型</div>
                  <div class="color-292a2e font-16 font-yahei">{{item.layout}}</div>
                </div>
                <div class="line"></div>
                <div>
                  <div class="color-94 font-12 mb-4">装修面积</div>
                  <div class="color-292a2e font-16 font-yahei">{{item.area}}</div>
                </div>
              </div>
            </div>
            <img src="/images/jinruxiangqingbaibeijing.png" alt="" class="ml-10">
          </div>
        </div>
      </div>
      <el-pagination layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Case',
  components: {},
  props: ['keywords'],
  computed: {},
  data () {
    return {
      styleList: [],
      styleIndex: -1,
      layoutList: this.Utils.houseType,
      layoutIndex: -1,
      areaIndex:-1,
      areaList: this.Utils.areaList,
      isSales: '',
      isPrice: '',
      page:1,
      limit: 16,
      total:0,
      caseList: []
    }
  },
  created () {
    this.getStyle()
    this.getData()
  },
  mounted () {
  },
   watch: {
    keywords (val) {
      this.keywords = val
      this.getData()
    }
  },
  methods: {
    getStyle() {
      this.axios
        .post("style/list",{})
        .then(res => {
          if (res.data.success) {
            this.styleList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getData () {
       this.axios.post(`cases/queryForPage`, {
        styleId: this.styleIndex >=0 ? this.styleList[this.styleIndex].id : '',
        layout:  this.layoutIndex >=0 ? this.layoutList[this.layoutIndex].name : '',
        minArea: this.areaIndex >=0 ? this.areaList[this.areaIndex].minArea : '',
        maxArea: this.areaIndex >=0 ? this.areaList[this.areaIndex].maxArea : '',
        keywords:this.keywords,
        limit: this.limit,
        page: this.page
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          this.caseList = list
          this.total = res.data.data.total
        }
      })
    },
    handleCurrentChange (e) {
      console.log(e)
    },
    chooseMenu (e, key) {
      this[key] = e
      this.getData()
    },
    toDetail (id) {
      let url = this.$router.resolve({name: 'CaseDetail',query: {id: id + '.html'}})
      window.open(url.href,'_blank')
    },
    onSort (key) {
      if (!key) {
        this.isSales = ''
        this.isPrice = ''
      } else {
        switch (this[key]) {
          case '':
            this.isSales = ''
            this.isPrice = ''
            this[key] = 1
          break
          case 1:
            this[key] = 0
          break
          case 0:
            this[key] = 1
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3 url('/images/kananlibg.png') no-repeat top center/auto 335px;
    padding-bottom: 105px;
  }
  .menu{
    padding: 30px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
    margin-bottom: 32px;
    .line{
      height: 24px;
      width: 1px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    .menu-item{
      padding: 0 10px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      color: #7d7d7d;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
    }
    .active{
      background: #f6efe6;
      color: #c19357;
    }
    .hr-dashed{
      width: 100%;
      height: 1px;
      border-bottom: 1px dashed #e9e9e9;
      margin: 16px 0;
    }
  }
  .sort{
    .line{
      width: 1px;
      height: 12px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    button {
      padding: 0;
    }
  }
  .case-item{
    width: 690px;
    padding: 30px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    .pic{
      width: 630px;
      height: 412px;
      border-radius: 4px;
      overflow: hidden;
    }
    .line{
      background: #e9e9e9;
      width: 1px;
      height: 40px;
      margin: 0 30px;
    }
    .mask{
      width: 630px;
      height: 412px;
      background: rgba($color: #c19357, $alpha: 0.85);
      position: absolute;
      top: 30px;
      left: 30px;
      border-radius: 4px;
      overflow: hidden;
      display: none;
    }
    &:hover{
      .mask {
        display: flex;
      }
    }
  }
  .w-124{
    width: 124px;
  }
</style>
